var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-overlay',{attrs:{"show":_vm.isShow,"custom-style":{
      background: 'rgb(255, 255, 255, 0.6)',
      display: 'flex',
      justifyContent: 'center',
    }},on:{"click":function($event){_vm.isShow = false}}},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"block"},[_c('van-loading',{attrs:{"type":"spinner","color":"#ffffff"}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }